//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum YandexMarketDeliveryType {
  /** Fulfillment By Yandex. */
  FBY = 1,
  /** Fulfillment By Seller. */
  FBS = 2,
  /** FBS with extra steps. */
  Express = 3,
  /** Delivery By Seller */
  DBS = 4,
  /** Fulfillment By Seller for Uzbekistan. */
  UzbFBS = 5,
  /** Fulfillment By Yandex for Uzbekistan. */
  UzbFBY = 6
}
